<template>
    <div class="section-banner section-banner--row" style="--bg: #f5f2ef;">
        <div class="section-container">
            <div class="story__body text--center">
                <h1 class="title" v-if="title" v-html="title" />
                <div v-html="text" />
            </div>
        </div>
    </div>
</template>

<script>
import { textProps, optionsProps } from './sectionProps'

export default {
    props: {
        ...textProps,
        ...optionsProps,
    },
}
</script>

<style lang="scss" scoped>
.section-banner {
    display: grid;
    width: 100%;
    background-color: var(--bg);
    margin-bottom: 3rem;

    @media (width < 768px) {
        margin-top: -77px;
        margin-bottom: 1rem;
    }
}

.section-banner--row {
    padding: calc(3rem + 80px) 2rem 4rem;

    .story__body, 
    .story__body > * {
        width: 100%;
        padding: 0;
        max-width: none;
    }

    .title {
        margin-block-end: 30px;
    }

    .title + p {
        margin-inline: auto;
        text-wrap: balance;
        max-width: 100%;
        max-inline-size: 80ch;
    }

    @media (width >= 768px) {
        padding: calc(5rem + 80px) 6em 6rem;
    }
}
</style>